export { SuiPopupModule, SuiPopupConfig, PopupTrigger } from "./index";
import { PositioningPlacement } from "../../misc/util/index";
export { PositioningPlacement as PopupPlacement };
//# sourceMappingURL=public.js.map


//////////////////
// WEBPACK FOOTER
// ../~/ng2-semantic-ui/dist/modules/popup/public.js
// module id = 1112
// module chunks = 0